$(function() {
  gsap.registerPlugin(ScrollTrigger);

  $(document).ready(function () {
    const $items = $('.cryo-steps .items');
    $items.each(function () {
      const $item = $(this);

      ScrollTrigger.create({
        trigger: $item,
        start: "40% 70%",
        end: "bottom top", 
        markers: false, 
        onEnter: () => {
          $('.cryo-steps .items').removeClass('active');
          $item.addClass('active');

          const index = $item.index(); 
          $('.cryo-buttons').removeClass('active'); 
          $('.cryo-buttons').eq(index).addClass('active');
        },
        onLeaveBack: () => {
          const $currentItem = $('.cryo-steps .items.active'); 
          const $prevItem = $currentItem.prev(); 


          if ($prevItem.length > 0 && $prevItem.hasClass('items')) {
            $currentItem.removeClass('active');
            $prevItem.addClass('active'); 

            const index = $prevItem.index(); 
            $('.cryo-buttons').removeClass('active'); 
            $('.cryo-buttons').eq(index).addClass('active'); 
          }
        },
      });
    });
  });

  $(document).on('click', '.cryo-steps .services-sticky .buttons .cryo-buttons', function (event) {
    event.preventDefault(); 


    const $index = $(this).index(); 
    const $target = $('.cryo-steps .items').eq($index); 
    const targetHeight  = $target.outerHeight();

    if ($target.length) {
      $('html, body').stop().animate({
        scrollTop: $target.offset().top - targetHeight/2,
      }, 800); 

      $('.cryo-buttons').removeClass('active');
      $(this).addClass('active');
    }
  });
  
  
});

    